// extracted by mini-css-extract-plugin
module.exports = {"root":"_2IhG5","title":"_2Q497","separator":"_3Wyjq","description":"_2VyQe","button":"_3b0TX"};